import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const location = useLocation();
  /* 바로 이동(/sso)이 실패하면 이유를 들고 온다 */
  const [error, setError] = useState((location.state as { message?: string } | null)?.message ?? '');
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/bids');
    }
  }, [isAuthenticated, navigate]);

  /* 누른 뒤 응답 전까지 버튼을 막는다 — 여러 번 눌렸다(#113) */
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || '로그인에 실패했습니다.');
      }

      await login(data.accessToken);
      navigate('/bids');
    } catch (err: any) {
      setError(err.message || '로그인에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100 px-4">
      <div className="w-full max-w-md mx-auto">
        {/* 로그인 카드 */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 md:p-10">
          <div className="text-center mb-8">
            <img
              src="/GRK_partners_가로형.jpg"
              alt="GRK Partners Logo"
              className="h-14 object-contain mx-auto mb-4"
            />
            <div className="text-sm font-medium tracking-[0.2em] text-slate-600 uppercase mb-2">
              PROJECT
            </div>
            <p className="text-sm text-slate-500">등록된 이메일과 비밀번호로 로그인하세요</p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-lg text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-700 mb-2">
                이메일
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="example@grkcon.com"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-2">
                비밀번호
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="비밀번호를 입력하세요"
                required
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-indigo-600 text-white py-3 px-5 rounded-lg hover:bg-indigo-700 transition-colors font-medium disabled:opacity-60"
            >
              {submitting ? '로그인 중…' : '로그인'}
            </button>
          </form>
        </div>

        <div className="mt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} GRK Project. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};
